<template>
	<div class="template mt-3">
    <template v-if="!loading">
      <template v-if="themeExist">
        <component :is="currentView"></component>
      </template>
      <template v-else>
        <component :is="'template-reporter'"></component>
      </template>
    </template>
	</div>
</template>

<script>
import reporter from '@/components/view/template/reporter/reporter'
import ecommerce from '@/components/view/template/ecommerce/ecommerce'
import oishineko from '@/components/view/template/oishineko/reporter'
import event from '@/components/view/template/event/Event'

export default {
  data: function() {
    return {
      // currentView: 'template-reporter'
      themeExist : false,
      loading: true,
      themes : [
        'reporter',
        'ecommerce',
        'ecommercebasic',
        'chatty',
				'oishineko',
        'oishineko2',
        'ananda',
        'event'
      ]

    }
  },
  // name: 'template',
  components: {
    'template-reporter': reporter,
    'template-ecommerce': ecommerce,
		'template-oishineko': oishineko,
    'template-oishineko2': oishineko,
    'template-event': event,
  },
  mounted: function(){
      let vm = this
      $.each(vm.themes,function(index, value){
        if (value == vm.$store.state.selectedBot.theme) {
          vm.themeExist = true
          vm.loading = false
          return false
        }
      })
      vm.loading = false
  },
  computed: {
    currentView: function(){
      if (!this.$store.state.selectedBot) {
          return null
      }
      let theme = this.$store.state.selectedBot.theme
      switch (theme) {
        case 'ecommercebasic':
        case 'chatty':
        case 'ananda':
          return 'template-ecommerce'
        default:
          return 'template-' + theme
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Template.vue